// The coins ORCA follows (the bot's TOP_CRYPTOCURRENCIES, 25 coins): display
// name, price decimals and the seed of the decorative sparkline. Reference
// data, not market data — prices come from the ORCA API.
export const COINS: Record<string, { name: string; decimals: number; sparkSeed: number }> = {
  BTC: { name: 'Bitcoin', decimals: 0, sparkSeed: 2 },
  ETH: { name: 'Ethereum', decimals: 2, sparkSeed: 9 },
  SOL: { name: 'Solana', decimals: 1, sparkSeed: 4 },
  TON: { name: 'Toncoin', decimals: 2, sparkSeed: 6 },
  LINK: { name: 'Chainlink', decimals: 2, sparkSeed: 13 },
  USDT: { name: 'Tether', decimals: 3, sparkSeed: 1 },
  XRP: { name: 'XRP', decimals: 3, sparkSeed: 3 },
  BNB: { name: 'BNB', decimals: 1, sparkSeed: 5 },
  DOGE: { name: 'Dogecoin', decimals: 4, sparkSeed: 7 },
  ADA: { name: 'Cardano', decimals: 3, sparkSeed: 8 },
  TRX: { name: 'TRON', decimals: 4, sparkSeed: 10 },
  SUI: { name: 'Sui', decimals: 3, sparkSeed: 11 },
  AVAX: { name: 'Avalanche', decimals: 2, sparkSeed: 12 },
  XLM: { name: 'Stellar', decimals: 4, sparkSeed: 14 },
  SHIB: { name: 'Shiba Inu', decimals: 7, sparkSeed: 15 },
  HBAR: { name: 'Hedera', decimals: 4, sparkSeed: 16 },
  DOT: { name: 'Polkadot', decimals: 3, sparkSeed: 17 },
  LTC: { name: 'Litecoin', decimals: 2, sparkSeed: 18 },
  PEPE: { name: 'Pepe', decimals: 7, sparkSeed: 19 },
  APT: { name: 'Aptos', decimals: 3, sparkSeed: 20 },
  ARB: { name: 'Arbitrum', decimals: 4, sparkSeed: 21 },
  OP: { name: 'Optimism', decimals: 4, sparkSeed: 22 },
  ATOM: { name: 'Cosmos', decimals: 3, sparkSeed: 24 },
  UNI: { name: 'Uniswap', decimals: 3, sparkSeed: 25 },
  AAVE: { name: 'Aave', decimals: 2, sparkSeed: 26 },
};
